let language = {
    TRANSFER_VOUCHER_INFO_REEOR_PARAM: "Required parameter missing",
    TRANSFER_VOUCHER_INFO_REEOR_PARAM_HINT: "Missing order ID, Click OK to return to the previous level",
    // TRANSFER_VOUCHER_INFO_REEOR_TITLE: "Failure to obtain information",
    // TRANSFER_VOUCHER_INFO_REEOR_HINT: "Failure to obtain information,Please click back to the previous level to re-enter",
    TRANSFER_VOUCHER_INFO_REEOR_TITLE: "Load error",
    TRANSFER_VOUCHER_INFO_REEOR_HINT: "Information acquisition failure",
    TRANSFER_VOUCHER_INFO_REEOR_HINT_500201: "Order does not exist",
   
    TRANSFER_VOUCHER_INFO_REEOR_HINT_5400010: "This order is not an offline trade order",
    TRANSFER_VOUCHER_ADD_REEOR_TITLE: "Add error",
    TRANSFER_VOUCHER_ADD_REEOR_HINT: "An error occurred. Add failed",
    TRANSFER_VOUCHER_ADD_REEOR_HINT_01: "Enter at least one transaction number to activate the transfer voucher",
    
    TRANSFER_VOUCHER_ADD_REEOR_HINT_04: "The transaction number and certificate have been uploaded on the background management page, please do not add it again",
    
    TRANSFER_VOUCHER_ADD_REEOR_HINT_05: "The order already has a transaction record.",
    
    TRANSFER_VOUCHER_ADD_REEOR_HINT_5400010: "Return to the previous level and try again",
    
    TRANSFER_VOUCHER_ADD_REEOR_HINT_5400027: "Order has been cancelled and cannot be added.",
    
    TRANSFER_VOUCHER_ADD_REEOR_HINT_500201: "Incorrect operation Click to return to previous level",
    TRANSFER_VOUCHER_UPDATE_REEOR_TITLE: "Update error",
    TRANSFER_VOUCHER_UPDATE_REEOR_HINT: "An error occurred and the modification failed",
    TRANSFER_VOUCHER_UPDATE_REEOR_HINT_01: "Enter at least one transaction number to activate the transfer voucher",
    
    TRANSFER_VOUCHER_UPDATE_REEOR_HINT_02: "Please add the transaction record first, or return to the previous level and try again",
    
    TRANSFER_VOUCHER_UPDATE_REEOR_HINT_03: "Transaction records have been reviewed and cannot be modified",
    
    TRANSFER_VOUCHER_UPDATE_REEOR_HINT_04: "The transaction number and certificate have been uploaded on the background management page, please do not add it again",
    
    TRANSFER_VOUCHER_UPDATE_REEOR_HINT_27: "The order has been cancelled and cannot be modified, please return to the previous level",

    TRANSFER_VOUCHER_PROOF_OF_PAYMENT:"Proof of payment:",
    TRANSFER_VOUCHER_SUBMIT_TRANSACTION_DETAILS:"Submit Transaction Details",
    TRANSFER_VOUCHER_PROOF_OF_PAYMENT_HINT:"Please upload up to 5 images (max 50 MB total) to confirm your payment. Accepted formats: JPG, JPEG, PNG, GIF, BMP, SVG, PDF.",
    TRANSFER_VOUCHER_REMITTANCE_TRANSACTION_NUMBER:"Remittance Transaction Number:",
    TRANSFER_VOUCHER_REMITTANCE_TRANSACTION_NUMBER_HINT:"(Click the + icon if you have more than one transaction number. You can enter up to 5 transaction numbers.)",
    TRANSFER_VOUCHER_REMARK: "Remark:",
    TRANSFER_VOUCHER_CANCEL: "CANCEL",
    TRANSFER_VOUCHER_SURE: "Sure",
    TRANSFER_VOUCHER_SUBMIT: "SUBMIT",
    TRANSFER_VOUCHER_BACK: "BACK",
    TRANSFER_VOUCHER_CONFIRM_UPLOAD:"Confirm Upload",
    
    TRANSFER_VOUCHER_CONFIRM_UPLOAD_HINT: "You tried to upload {{currentUploadNum}} pictures, we can only upload{{allowUploadNum}} for you. Do you want to continue?",
    TRANSFER_VOUCHER_UPLOAD: "Upload",
    TRANSFER_VOUCHER_UPLOAD_HINT: "There are {{failedFileslength}} pictures over 50MB or file format is not allowed, we can only upload {{verifySuccessFileslength}} for you.",
    
    TRANSFER_VOUCHER_UPLOAD_HINT_01: "There are {{failedFileslength}} pictures over 50MB or file format is not allowed, we can only upload {{verifySuccessFileslength}} for you.",
}

export { language }